import { render, staticRenderFns } from "./jichu.vue?vue&type=template&id=39975cee"
import script from "./jichu.vue?vue&type=script&lang=js"
export * from "./jichu.vue?vue&type=script&lang=js"
import style0 from "./jichu.vue?vue&type=style&index=0&id=39975cee&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports